import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { TGeneral } from '~/src/types/common'

const DEFAULT_MODALS = {
  signInOpen: false,
  forgotPasswordOpen: false,
  contactOpen: false,
  subscribeOpen: false,
  fileUploaderOpen: false,
  requestForProposalOpen: false,
  esgReportsOpen: false,
  eventsModalOpen: false,
  priceAssessmentFiltersOpen: false,
  priceAssessmentControlDocumentsOpen: false,
  mobileMenuOpen: false,
  mobileAccountMenuOpen: false,
  tableIndexShareOpen: false,
  newsletterOpen: false,
  capexTrackerOpen: false,
  trialConversionsOpen: false,
  updateAccountDetailRequestOpen: false,
  changePasswordOpen: false,
  eventOpen: false,
  videoIntroOpen: false,
  capexTrackerContactOpen: false,
  industryReportsOpen: false,
  chartBuilderResetOpen: false,
  chartBuilderCloseOpen: false,
  deleteWatchlistOpen: false,
  chartBuilderDataSeriesWarningOpen: false,
  clearChartOpen: false,
  allPricesTableOpen: false,
  mineToGridOpen: false,
  hubspotMeetingSchedulerOpen: false,
  downloadBrochureOpen: false,
  homeCopperOpen: false,
  pdfViewerModalOpen: false,
  createAccountOpen: false,
  marketsOfInterestOpen: false,
  newsletterPreferencesOpen: false,
  impersonatingOpen: false,
  priceAssessmentScheduleExceptionsOpen: false,
  signInPriceSpotlightVariantOpen: false,
  PriceSpotlightFlourishOpen: false,
}

export const useModalStore = defineStore('modal', () => {
  const modals = ref(DEFAULT_MODALS)
  const callback = ref(null)
  const initialFields = ref<any>(null)
  const modalParams = ref<any>(null)
  const subscriptionRenewData = ref<TGeneral>({})
  const isPriceSpotlightLoginVariantActive = ref(false)

  const open = (modalName: string) => {
    modals.value[`${modalName}Open`] = true
  }

  const close = (modalName: string) => {
    modals.value[`${modalName}Open`] = false
  }

  const setRenewData = (data: Record<string, any>) => {
    subscriptionRenewData.value = data
  }

  const setInitialFields = (fields: any) => {
    initialFields.value = fields
  }

  const getModal = (modalName: string): boolean => {
    return modals.value[`${modalName}Open`]
  }

  const setModalParams = (params: any) => {
    modalParams.value = params
  }

  const setPriceSpotlightLoginVariantActive = (isActive: boolean) => {
    isPriceSpotlightLoginVariantActive.value = isActive
  }

  const hasModalOpen = computed(() =>
    Object.values(modals.value).some((modal) => modal === true),
  )

  return {
    modals,
    callback,
    initialFields,
    modalParams,
    subscriptionRenewData,
    hasModalOpen,
    isPriceSpotlightLoginVariantActive,
    getModal,
    open,
    close,
    setRenewData,
    setInitialFields,
    setModalParams,
    setPriceSpotlightLoginVariantActive,
  }
})
